import type { UserOut } from '../lib/api'
import { create } from 'zustand'
import { api } from '../lib/api'

interface AuthState {
  user: UserOut | null
  loading: boolean
  setUser: (u: UserOut | null) => void
  refresh: () => Promise<void>
  logout: () => Promise<void>
}

export const useAuth = create<AuthState>((set) => ({
  user: null,
  loading: true,
  setUser: (u) => set({ user: u, loading: false }),
  refresh: async () => {
    set({ loading: true })
    try {
      const res = await api.get<UserOut>('/auth/me')
      set({ user: res.data, loading: false })
    } catch {
      set({ user: null, loading: false })
    }
  },
  logout: async () => {
    try {
      await api.post('/auth/logout')
    } finally {
      set({ user: null })
    }
  },
}))
